<template>
  <div id="page_faq">
    <div class="banner">
      <img src="../assets/img/service_qnabg.jpg" alt="" class="bg">
      <div class="textbox">
        <h2 class="wow fadeInDown">FAQ</h2>
      </div>
    </div>
    <div id="part4" class="full">
      <div class="mainTitle1 textbox">
        <h3>Trusted By Our Customers</h3>
        <p>We care about all the questions you worry about and have made preliminary answers. For more questions, please contact us.</p>
      </div>
      <div class="faqbox">
        <el-collapse class="item" v-model="activeNames[index]" v-for="(item,index) in FAQList" :key="index">
          <el-collapse-item :title="item.title" name="1">
            <p>{{item.text}}</p>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
export default {
  name: "Faq",
  components:{
  },
  metaInfo:{
    title:'Guangdong Brotex Acoustic Technology Co.,Ltd | Faq',
  },
  data(){
    return{
      serviceList:[
        {
          name:'Designing',
          text:'Our goal is to exceed customers’ expectations while ensuring that the products are durable, well-designed, and can stand the test of time.',
          font:'icon-bianji-2',
        },
        {
          name:'Producing',
          text:'We have experienced professional workers devoted in producing acoustic products. Absolutely they are the best and real maker! ',
          font:'icon-shezhi',
        },
        {
          name:'Quality Control',
          text:'Our products are 100% passed the quality inspection. Each working procedure escorts the health and utility of users.',
          font:'icon-renzheng',
        },
        {
          name:'Competitive Prices',
          text:'We are well aware of the acoustic industry standards, we have been striving to provide you with the most competitive product prices.',
          font:'icon-zhifu',
        },
        {
          name:'Packaging',
          text:'We\'ll determine the way of packing according to the actual situation of the goods, we offer the best packing service to ensure that your acoustic penals will be delivered to you intact.',
          font:'icon-list',
        },
        {
          name:'After-Sale Service',
          text:'We will give you immediate feedback whether it is suggestions, comments, criticisms or problems in use. Feel free to contact us.',
          font:'icon-jiating',
        },
      ],
      email:'',
      flowList:[
        {
          class:'icon-check',
          name:'Product Selection',
        },
        {
          class:'icon-yue',
          name:'Quotation',
        },
        {
          class:'icon-talk',
          name:'Negotiation',
        },
        {
          class:'icon-list',
          name:'Confirm Order',
        },
        {
          class:'icon-house',
          name:'Production',
        },
        {
          class:'icon-deal',
          name:'Deal',
        },
        {
          class:'icon-y-receiptconfirmation',
          name:'Confirm Receipt',
        },
        {
          class:'icon-Orderdelivery',
          name:'Delivery/Cargo',
        },
        {
          class:'icon-fukuan',
          name:'Balance Payment',
        },
        {
          class:'icon-inspection-fill',
          name:'Inspection',
        },
      ],
      activeNames:[0,0,0,0,0,0],
      FAQList:[
        {
          title:'I just placed my order. When can I expect delivery?',
          text:'Thanks for your business! We build everything to order, and typically orders are shipped within 2 weeks delivery. If you need any special accommodations for shipping, please contact us directly.',
        },
        {
          title:'Can I order custom-sized panels?',
          text:'We can absolutely manufacture acoustic panels to your specifications. We’ve done all sorts of custom orders from smaller sizes to extra large panels.',
        },
        {
          title:'What\'s inside your panels?',
          text:'Patented Logo, our goal is to provide customers with acoustic treatments they can depend on for years to come, so we use quality materials to manufacture products that outshine everything else on the market. batteries. But free samples are not available at the beginning.',
        },
        {
          title:'How can I pay? What are the terms of payment?',
          text:'T/T, L/C, Paypal, Western Union, Trading Assurance Order, etc.',
        },
        {
          title:'What is the mode of transportation? How about the time limit?',
          text:'Small quantity by DHL, UPS, FedEx express, it will take about 5 -7 days; Bulk goods by sea, and the transportation time depends on the distance.',
        },
        // {
        //   title:'What is the mode of transportation?How about the time limit?',
        //   text:'Small quantity batteries by DHL, UPS, FedEx express, it will take about 5 -7 days; Bulk goods by train or by air or by sea,transportation time depends on the distance.',
        // },
        // {
        //   title:'Can you accept OEM and ODM service?',
        //   text:'Yes, we can supply OEM and ODM services according to clients requirement.',
        // },
      ],
    }
  },
  created() {
    this.$emit('getnav',5)
  },
  mounted() {
    this.$nextTick(()=>{
      let wow = new WOW({
        live:false
      })
      wow.init()
    })
  }
}
</script>

<style lang="less" scoped>
#page_faq{
  .banner{position: relative;z-index: 1;padding: 0.7rem 3%;text-align: center;overflow: hidden;
    .bg{position: absolute;bottom: 0;right: 0;z-index: -1;}
    .textbox{
      h2{color: white;}
    }
    .crumb{font: 20px Poppins-SemiBold;margin-top: 60px;
      a{color: white;
        &:not(:last-child):after{content: '>';margin: 0 20px;}
        &:last-child{border-bottom: 1px solid white;}
      }
    }
  }
  #part1{
    .itembox{flex-wrap: wrap;
      .item{width: calc(33.333333% - 20px);text-align: center;padding: 40px 20px;transition: .3s;margin-bottom: 30px;color: @main-c4;
        *{transition: .3s;}
        .iconfont{font-size: 50px;}
        h4{margin: 10px 0;}
        P{font: 15px Poppins-Regular;color: @main-c2;}
        &:hover{box-shadow: 0 0 30px -5px rgba(0,0,0,.08);
          .iconfont{color: @main-c1;}
        }
      }
    }
  }
  #part2{background: #F5F5F5;padding-bottom: 20px;
    .mainTitle1{margin-bottom: 45px;}
    .flowbox{display: flex;flex-wrap: wrap;padding: 0% 0;position: relative;z-index: 1;
      .bg{position: absolute;z-index: -1;}
      .item{width: 20%;text-align: center;margin-bottom: 86px;
        .iconfont{font-size: 32px;color: @main-c1;border-radius: 50%;width: 65px;height: 65px;background: @main-c4;display: flex;align-items: center;justify-content: center;margin: 0 auto 10px;transition: .3s;}
        p{font: 20px Poppins-SemiBold;color: @main-c4;}
        &:nth-last-child(-n+5){margin-bottom: 0;}
        &:hover{
          .iconfont{transform: scale(1.2);background: @main-c1;color: @main-c4;}
        }
      }
    }
  }
  .slogan{background: @main-c2;padding: 70px 200px;color: white;text-align: center;
    .inputbox{margin-top: 50px;display: flex;justify-content: center;
      input{border: none;background: #F5F5F5;padding: 10px 20px;font: 14px Poppins-Regular;width: 30%;
        &::-webkit-input-placeholder{font: 14px Poppins-Regular;}
      }
      .btn{padding: 10px 40px;font: 22px Poppins-SemiBold;background: @main-c1;margin-left: 10px;color: @main-c2;cursor: pointer;}
    }
  }
  #part3{display: flex;background: url("../assets/img/product_part2bg.jpg") no-repeat 50% 50%/cover;
    .mainTitle1{margin: 0 ;
      h3{margin-bottom: 40px;}
      p{width: 50%;}
    }
  }
  #part4{background: #F5F5F5;
    //background: url("../assets/img/service_qnabg.jpg") no-repeat 50% 50%/cover fixed;
    .faqbox{display: flex;justify-content: space-between;flex-wrap: wrap;margin: 0;width: 100%;
      .item{width: 100%;border: none;overflow: hidden;margin: 0 0px 2%;height: auto;
        /deep/ .el-collapse-item__header{width: 100%;border: none;overflow: hidden;height: auto;background: #F6F6F6;font: .14rem/.18rem Poppins-SemiBold;color: @main-c2;
          transition: .6s;padding: .1rem;background: #fff;
          //&.is-active{color: white;background: @main-c2;}
        }
        /deep/ .el-collapse-item__content{padding: .1rem;background: transparent;
          p{font: .12rem/.16rem Poppins-Regular;}
        }
        /deep/ .el-collapse-item__wrap{border: none;background: transparent;}
        &:nth-last-child(-n+1){margin-bottom: 0;}
      }
      .item:hover{
        img{animation: flipInY 1s;}
        .cover{left: 50%;}
      }
    }
  }
}
</style>